import { connect } from "react-redux";
import BVAInput from "../../../../components/BVAInput/BVAInput";

function FeeItem({ assumptions, name, handleChange}) {
  return (
    <>
      <div className="flex items-center mb-5 px-10">
        <div className="w-1/2 text-lg">{name} Fee (Percentage of Total Cash Contribution)</div>
        <div className="w-1/4 text-center">
          <BVAInput
            size="small"
            width="170px"
            endAdornment
            endAdornmentLabel="%"
            value={assumptions["GP" + name + "FeePercent"]}
            onChange={(value) => handleChange("GP" + name + "FeePercent", value)}
          />
        </div>
        <div className="w-1/4 text-center">
          <BVAInput
            size="small"
            width="170px"
            endAdornment
            endAdornmentLabel="%"
            value={assumptions["LP" + name + "FeePercent"]}
            onChange={(value) => handleChange("LP" + name + "FeePercent", value)}
          />
        </div>
      </div>
      <div className="flex items-center mb-5 px-10">
        <div className="w-1/2 text-lg">Annual {name} Fee Amount</div>
        <div className="w-1/4 text-center">
          <BVAInput
            size="small"
            width="170px"
            disabled
            endAdornment
            endAdornmentLabel="$"
            value={assumptions["GP" + name + "FeeAmount"]}
          />
        </div>
        <div className="w-1/4 text-center">
          <BVAInput
            size="small"
            width="170px"
            disabled
            endAdornment
            endAdornmentLabel="$"
            value={assumptions["LP" + name + "FeeAmount"]}
          />
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

export default connect(mapStateToProps, null)(FeeItem);